export class MenuAdjuster {
  static init(navOpenObj) {
    // eslint-disable-next-line no-script-url
    $('.footer-navigation__item--menu-item-object-kompetenzgruppe > a')
    .css('cursor', 'default')
    .attr('href', 'javascript:void(0)');
    // eslint-disable-next-line no-script-url
    $('.main-navigation__item--menu-item-object-kompetenzgruppe > a')
    .css('cursor', 'default')
    .attr('href', 'javascript:void(0)');
    // eslint-disable-next-line no-script-url
    $('.main-navigation__item--menu-item-object-ausbildungsart > a')
    .css('cursor', 'default')
    .attr('href', 'javascript:void(0)');
    // eslint-disable-next-line no-script-url
    $('.main-navigation__item--menu-item-object-page.main-navigation__item--menu-item-has-children > a')
    .css('cursor', 'default')
    .attr('href', 'javascript:void(0)');

    $('#header__icon-home').click(function() {
      MenuAdjuster.showMobileNav();
      navOpenObj.navOpen = true;
    });

    $('#header__icon-exit').click(function() {
      MenuAdjuster.hideMobileNav();
      navOpenObj.navOpen = false;
    });

    MenuAdjuster.adjustMenu(navOpenObj);
    $(window).resize(function() {
      MenuAdjuster.adjustMenu(navOpenObj);
    });

  }

  static adjustMenu(navOpenObj) {
    if (window.innerWidth > 576) {
      $('.main-navigation').css('display', 'flex');
    } else if (!navOpenObj.navOpen) {
      $('.main-navigation').css('display', 'none');
    }
    if (window.innerWidth > 900) {
      $('.main-navigation__item--menu-item-object-kompetenz > .main-navigation__sub-menu--1').addClass('main-navigation__sub-menu--1--two-columns');
    } else {
      $('.main-navigation__item--menu-item-object-kompetenz > .main-navigation__sub-menu--1').removeClass('main-navigation__sub-menu--1--two-columns');
    }
  }
  static showMobileNav() {
    $('#header__icon-exit').css('display', 'block');
    $('#header__icon-home').css('display', 'none');
    $('.header').addClass('header__mobile-nav');
    $('.main-navigation').css('display', 'flex');
    $('html, body').css({
      overflow: 'hidden',
      height: '100%',
    });
  }

  static hideMobileNav() {
    $('#header__icon-exit').css('display', 'none');
    $('#header__icon-home').css('display', 'block');
    $('.header').removeClass('header__mobile-nav');
    $('.main-navigation').css('display', 'none');
    $('html, body').css({
      overflow: 'auto',
      height: 'auto',
    });
  }

}
